var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.65926 9.77395L1.64594 8.7606C1.2326 8.34727 1.2326 7.66726 1.64594 7.25393L2.65926 6.24058C2.8326 6.06725 2.9726 5.72725 2.9726 5.48725V4.0539C2.9726 3.46723 3.4526 2.98725 4.03927 2.98725H5.4726C5.7126 2.98725 6.0526 2.84727 6.22593 2.67393L7.23926 1.66059C7.65259 1.24725 8.3326 1.24725 8.74593 1.66059L9.75928 2.67393C9.93261 2.84727 10.2726 2.98725 10.5126 2.98725H11.9459C12.5326 2.98725 13.0126 3.46723 13.0126 4.0539V5.48725C13.0126 5.72725 13.1526 6.06725 13.3259 6.24058L14.3393 7.25393C14.7526 7.66726 14.7526 8.34727 14.3393 8.7606L13.3259 9.77395C13.1526 9.94728 13.0126 10.2873 13.0126 10.5273V11.9606C13.0126 12.5472 12.5326 13.0273 11.9459 13.0273H10.5126C10.2726 13.0273 9.93261 13.1673 9.75928 13.3406L8.74593 14.3539C8.3326 14.7673 7.65259 14.7673 7.23926 14.3539L6.22593 13.3406C6.0526 13.1673 5.7126 13.0273 5.4726 13.0273H4.03927C3.4526 13.0273 2.9726 12.5472 2.9726 11.9606V10.5273C2.9726 10.2806 2.8326 9.94061 2.65926 9.77395Z",
    stroke: "#175CD3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10L10 6",
    stroke: "#175CD3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66305 9.66634H9.66903",
    stroke: "#175CD3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32967 6.33333H6.33566",
    stroke: "#175CD3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.f58d6ca67d9c755999fbefda8e08aa68.svg";
export { ForwardRef as ReactComponent };